import React from 'react'
import PropTypes from 'prop-types'
import analysisIcon from '../../../../assets/img/analysis.svg'
import clsx from 'clsx'
import { Paper, Grid } from '@material-ui/core'

const PreviewCols = props => {
  let cols = []
  const { columns, height, classes } = props

  for (let i = 0; i < columns; i++) {
    cols.push(
      <Paper
        className={clsx(`u-m-zero u-text-center`)}
        style={{
          height: `${height}px`,
        }}
      >
        <img
          alt={'preview icon'}
          src={analysisIcon}
          style={{
            width: 'auto',
            height: `${parseInt(height) - 20}px`,
          }}
          className={'u-m-auto'}
        />
      </Paper>
    )
  }

  return (
    <Grid container spacing={1}>
      {cols.map((col, index) => (
        <Grid item key={index} sm>
          {col}
        </Grid>
      ))}
    </Grid>
  )
}

PreviewCols.propTypes = {
  classes: PropTypes.object.isRequired,
  height: PropTypes.number.isRequired,
  columns: PropTypes.number.isRequired,
}

export default PreviewCols
